module.exports = __webpack_public_path__ + "assets/a9fa09b3fdea9b472e7c4ada673d4b14.png";